<template>
    <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-800">
        <authentication-card-logo dusk="login-screen-logo"/>
        <div class="flex justify-center bg-gray-800 text-white" dusk="login-screen-logo">POS ADMIN</div>

        <div class="w-full sm:max-w-md mt-6 px-6 py-4 bg-gray-100 shadow-md overflow-hidden sm:rounded-lg border border-gray-700">
            <form @submit.prevent="submitForm">
                <template v-if="admin && user">
                    <div>
                        {{ $t('You are going to impersonate as') }} <strong>{{ user }}</strong>
                    </div>
                    <div>
                        {{ $t('Please type your backoffice password') }}
                    </div>
                </template>
                <template v-else>
                    <div>
                        <label for="email" class="block font-medium text-sm text-gray-700">{{ $t('Username') }}</label>
                        <input id="email" class="form-input rounded-md shadow-sm block mt-1 w-full" type="text" name="username" v-model="form.username" required autofocus>
                    </div>
                </template>

                <div class="mt-4">
                    <label for="password" class="block font-medium text-sm text-gray-700">{{ $t('Password') }}</label>
                    <input id="password" class="form-input rounded-md shadow-sm block mt-1 w-full" type="password" name="password" v-model="form.password" required autocomplete="current-password">
                </div>

                <validation-errors :errors="errors" />

                <div class="flex items-center justify-end mt-4">
                    <button type="submit" class="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray disabled:opacity-25 transition ease-in-out duration-150 ml-4" dusk="login-button">
                        {{ $t('Login') }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import ValidationErrors from "../../Shared/Components/ValidationErrors.vue";
import AuthenticationCardLogo from "../../Shared/Components/AuthenticationCardLogo.vue";

export default {
    name: 'PosLogin',
    components: {AuthenticationCardLogo, ValidationErrors},
    props: {
        imageUrl: String,
        admin: {
            type: String,
            default: null
        },
        user: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            form: {
                username: '',
                password: '',
            },
            errors: [],
        }
    },
    methods: {
        updateHiddenUsername() {
            if (this.admin && this.user) {
                this.form.username = `${this.admin}:${this.user}`;
            }
        },
        async submitForm() {
            await axios.get('/sanctum/csrf-cookie');
            this.updateHiddenUsername();
            await axios.post(this.route('login'), this.form).then(() => {
                window.location.replace(this.route('pos.home').url());
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    this.errors = Object.values(error.response.data).flat();
                } else if (error.response && error.response.status === 419) {
                    // CSRF token mismatch.
                    this.errors = ['Session expired. Please refresh the page and try again.'];
                }
            });
        },
    },
}
</script>
